"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FetchClient_1 = __importDefault(require("./FetchClient"));
class SylexClient extends FetchClient_1.default {
    siteId;
    draftMode;
    site;
    constructor({ apiKey, siteId, draftMode = false, ...baseSrc }) {
        super(baseSrc);
        this.headers['Authorization'] = `users API-Key ${apiKey || ''}`;
        this.siteId = siteId || 0;
        this.site = null;
        this.draftMode = draftMode ? 'true' : 'false';
    }
    async getAllPaginated(url, params = { page: '1', limit: '20' }) {
        const searchParams = new URLSearchParams(params);
        const query = `${url}?${searchParams.toString()}`;
        const initialRes = await this.get(query).then((r) => r.body || []);
        if (initialRes.totalPages <= 1)
            return initialRes.docs || [];
        const promises = [];
        // Start from the next page
        for (let i = initialRes.page + 1; i <= initialRes.totalPages; i++) {
            const nextPageParams = { ...params, page: i.toString() };
            const nextPageQuery = `${url}?${new URLSearchParams(nextPageParams).toString()}`;
            promises.push(this.get(nextPageQuery).then((r) => r.body.docs || []));
        }
        const results = await Promise.all(promises);
        return [...initialRes.docs, ...results.flat()];
    }
    async getPages() {
        const params = {
            'where[site][equals]': this.siteId.toString(),
            draft: this.draftMode,
            depth: '5',
        };
        if (this.draftMode === 'false') {
            params['where[excludeFromProduction][not_equals]'] = 'true';
        }
        return this.getAllPaginated('api/pages', params);
    }
    async getThemes() {
        const params = {
            'where[sites][contains]': this.siteId.toString(),
            depth: '1',
        };
        return this.getAllPaginated('api/themes', params);
    }
    async getPosts() {
        const params = {
            'where[site][equals]': this.siteId.toString(),
            draft: this.draftMode,
        };
        if (this.draftMode === 'false') {
            params['where[excludeFromProduction][not_equals]'] = 'true';
        }
        return this.getAllPaginated('api/posts', params);
    }
    async getSite() {
        if (this.site) {
            return this.site;
        }
        const res = await this.get(`api/sites?where[id][equals]=${this.siteId}&limit=1&depth=0`);
        if (!res.body.docs.length)
            return null;
        this.site = res.body.docs[0];
        return res.body.docs[0];
    }
    async getForms() {
        return this.getAllPaginated('api/forms', {
            'where[site][equals]': this.siteId.toString(),
            depth: '3',
            draft: this.draftMode,
        });
    }
    async getHeaders() {
        const params = {
            'where[site][equals]': this.siteId.toString(),
            draft: this.draftMode,
        };
        return this.getAllPaginated('api/headers', params);
    }
    async getFooters() {
        const params = {
            'where[site][equals]': this.siteId.toString(),
            draft: this.draftMode,
        };
        return this.getAllPaginated('api/footers', params);
    }
    async getDisclaimers() {
        const site = await this.getSite();
        if (!site || typeof site.brand !== 'number') {
            console.warn('No site found or brand is not a number', site);
            return [];
        }
        return this.getAllPaginated(`api/disclaimers`, {
            'where[brands][equals]': site.brand.toString(),
            draft: this.draftMode,
        });
    }
}
exports.default = SylexClient;
